<template>
  <div>
    <div class="index-wrap index-wrapabout" style="background:none">
      <div class="index-menu menuBg">
        <div class="header-main">
          <div class="menu">
            <a class="logo" href="javascript:;">
              <img src="../../public/assets/img/logo.png">
            </a>
            <div class="menu_left">
              <router-link to="/" exact active-class="active" class="anchor-link">首页</router-link>
              <router-link :to="{ name: 'ServiceList' }" class="anchor-link">服务列表</router-link>
              <router-link :to="{ name: 'PayMent' }" class="anchor-link">付费方式</router-link>
              <router-link :to="{ name: 'IntroduceAbout' }" class="anchor-link">关于我们</router-link>
            </div>
            <div class="phone">
              19567978183
            </div>
            <div class="info">
              <!-- {{ user }} -->
              <div v-if="user">
                <a href="https://vip.zhaobiaoguancha.cn/user/index" style="color:white">会员中心</a>
                <div class="user-info" style="display:none">
                  <div class="header-usermenu">
                    <a href="javascript:;" class="header-title show_nickname">{{ user.username }}</a>
                  </div>
                </div>
              </div>
              <div v-else>
                <div class="loginReg">
                  <a class="reg" href="https://vip.zhaobiaoguancha.cn/user/login?tab=register">注册</a>
                  <a class="login" href="https://vip.zhaobiaoguancha.cn/user/login?tab=login">登录</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="procedure">
        <div class="procedure-one">
          <h3>会员办理流程</h3>
        </div>
        <table cellspacing="20" cellpadding="20">
          <tr>
            <td class="tableIndex">01</td>
            <td class="tableTheme">注册采购网会员</td>
            <td class="tableCon">注册中国招标采购网会员。</td>
          </tr>
          <tr>
            <td class="tableIndex" style="color: #b6d000">02</td>
            <td class="tableTheme" style="background: #b6d000">选择会员地区</td>
            <td class="tableCon">了解付费会员权益,选择会员地区以及合作年限。</td>
          </tr>
          <tr>
            <td class="tableIndex" style="color: #e17700">03</td>
            <td class="tableTheme" style="background: #e17700">填写协议</td>
            <td class="tableCon">
              确定会员地区后将由您的销售专员将协议发送给您，填写完成后的协议，请您加盖公章传回中国招标采购网。
            </td>
          </tr>
          <tr>
            <td class="tableIndex" style="color: #c20018">04</td>
            <td class="tableTheme" style="background: #c20018">进行支付</td>
            <td class="tableCon">按合同金额将款项支付到账，付款方式如本页面所示。</td>
          </tr>
          <tr>
            <td class="tableIndex" style="color: #7e00cd">05</td>
            <td class="tableTheme" style="background: #7e00cd">采购网确认</td>
            <td class="tableCon">
              将汇款底单传回中国招标采购网，中国招标采购网收到汇款底单后会为您开放付费会员权限， 如果您需要帮助，咨询热线：
              19567978183
            </td>
          </tr>
        </table>
        <div class="procedure-one">
          <h3>银行转账支付</h3>
        </div>
        <div class="message">
          <h3>对公汇款：</h3>
          <p>收款人：河北泽能信息科技有限公司</p>
          <p>开户行：中国民生银行石家庄合作路支行</p>
          <p>账号：154401683</p>
        </div>
        <div class="procedure-one">
          <h3>特别提示：</h3>
        </div>
        <div class="tips">
          <p>1、请在转账时务必仔细核对转账信息以免造成退汇、错汇，延误对您的服务；</p>
          <p>2、为了不影响您的开通时间，请在转账时尽量选择实时到账；</p>
          <p>3、个人名称汇款只能开具增值税普票。</p>
          <p>遇到问题或疑问，请及时联系我们：0311-88557455。</p>
        </div>
      </div>
      <div class="footer">
        <p class="copyright">
          © 2017-2025 招标采购网 All Rights Reserved. Power By 京源
        </p>
      </div>
    </div>
  </div>
</template>

<script>
// import Header from "@/components/HeaderInfo.vue";
// import FooterInfo from "@/components/FooterInfo.vue";
export default {
  // comments: { Header, FooterInfo },
  data() {
    return {
      user: false, // 根据实际情况设置是否登录
    };
  },
};
</script>
